"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.del = del;
exports.findByFlowInstId = findByFlowInstId;
exports.findById = findById;
exports.getFileList = getFileList;
exports.getFileName = getFileName;
exports.listAttach = listAttach;
exports.submit = submit;
exports.update = update;
exports.uploadFile = uploadFile;
var _request = _interopRequireDefault(require("@utils/request"));
var _cloud = require("@utils/cloud");
// 分页
function listAttach(query) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/sys/attach-file/list',
    method: 'POST',
    params: query
  });
}

// id 查询
function findById(id) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/sys/attach-file/' + id,
    method: 'get'
  });
}

// 流程实例 id 查询
function findByFlowInstId(id) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/sys/attach-file/findByFlowInstId/' + id,
    method: 'get'
  });
}

// 修改
// export function update(data) {
// 	return request({
// 		url: urls.projectName + '/sys/attach-file',
// 		method: 'put',
// 		data: data
// 	})
// }

// 保存
function add(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/sys/attach-file',
    method: 'post',
    data: data
  });
}

// 提交
function submit(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/sys/attach-file/submit',
    method: 'post',
    data: data
  });
}

// 更新
function update(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/sys/attach-file/update',
    method: 'post',
    data: data
  });
}

//删除
function del(id) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/sys/attach-file/del',
    method: 'delete',
    params: {
      id: id
    }
  });
}

// 查询重名文件
function getFileName(menuRoute, name) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/sys/attach-file/getFileName',
    method: 'get',
    params: {
      menuRoute: menuRoute,
      name: name
    }
  });
}

// 上传文件
function uploadFile(formData) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/sys/attach-file/getFileName',
    method: 'post',
    data: formData
  });
}

// 获取图片
function getFileList(menuRoute, formId) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/sys/attach-file/getFileList',
    method: 'get',
    params: {
      menuRoute: menuRoute,
      formId: formId
    }
  });
}